import React, { Component } from 'react';
import load from 'loadjs';

import { LayoutComponent_LocalLoader as Loader } from 'ggApp/modules/layout';
import loadConfiguration from 'ggApp/utils/configuration';
import { ADYEN_PAYMENT_CC } from 'ggApp/modules/adyen/constants';

import Form from '../Form';

const { ADYEN_PUBLIC_KEY, ADYEN_LIBRARY_URL } = loadConfiguration();

// TODO: extract into adyen module utilities for reuse in new chekcout
const dataNormalizer = ({ cardNumber, cvc, holderName, expiry }) => {
    const expArray = expiry ? expiry.split('/') : [];

    return {
        cardNumber: cardNumber && cardNumber.replace(/\s/g, ''),
        cvc: cvc && cvc.replace(/\s/g, ''),
        holderName: holderName.toUpperCase(),
        expiryMonth: expArray[0] ? expArray[0].replace(/\s/g, '') : '',
        expiryYear: expArray[1] ? expArray[1].replace(/\s/g, '') : '',
    };
};

class FormWrap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adyenInstance: null,
            loadingAdyenLibrary: true,
        };
        this.canUpdateState = true;
    }

    componentDidMount() {
        if (ADYEN_LIBRARY_URL) {
            load(ADYEN_LIBRARY_URL, {
                success: this.adyenOnLoad,
                error: this.adyenOnLoadError,
            });
        }
    }

    componentWillUnmount() {
        const { adyenActions } = this.props;

        this.canUpdateState = false;
        adyenActions.resetSubmittedPaymentError();
    }

    onSubmit = (values) => {
        const { adyenActions } = this.props;
        const normalizedData = dataNormalizer(values);
        const encryptedData = this.encryptMyData(normalizedData);
        adyenActions.savePaymentData(ADYEN_PAYMENT_CC, {
            card: normalizedData,
            encryptedCard: encryptedData,
        });
        setTimeout(() => this.addPaymentGateway(), 0);
    };

    addPaymentGateway = () => {
        const {
            orderNumber,
            adyenActions,
            adyenSavedPaymentData,
            onLegacyPaymentMethodCreated,
        } = this.props;
        if (adyenSavedPaymentData.type && Object.keys(adyenSavedPaymentData.data).length !== 0) {
            return adyenActions
                .submitPayment(adyenSavedPaymentData.type, adyenSavedPaymentData.data, orderNumber)
                .then(onLegacyPaymentMethodCreated)
                .catch((error) => console.warn(error));
        }
        return Promise.resolve(null);
    };

    adyenOnLoad = () => {
        if (this.canUpdateState) {
            this.setState({
                loadingAdyenLibrary: false,
            });

            if (window && window.adyen) {
                this.setState({
                    adyenInstance: window.adyen.createEncryption(ADYEN_PUBLIC_KEY),
                });
            }
        }
    };

    adyenOnLoadError = () => {
        if (this.canUpdateState) {
            this.setState({
                loadingAdyenLibrary: false,
            });
        }
    };

    encryptMyData = ({ cardNumber, cvc, holderName, expiryMonth, expiryYear }) => {
        const { adyenInstance } = this.state;
        const data = {
            number: cardNumber,
            cvc,
            holderName,
            expiryMonth,
            expiryYear: `20${expiryYear}`,
            generationtime: `${new Date().toISOString()}`,
        };

        return adyenInstance.encrypt(data);
    };

    render() {
        const { adyenInstance, loadingAdyenLibrary } = this.state;
        const { formValues, adyenSubmittedPayment, darkTheme } = this.props;
        if (loadingAdyenLibrary) {
            return <Loader dark main active={loadingAdyenLibrary} />;
        }
        return !adyenInstance ? null : (
            <Form
                onSubmit={this.onSubmit}
                showCard
                formValues={formValues}
                adyenSubmittedPayment={adyenSubmittedPayment}
                dark={darkTheme}
            />
        );
    }
}

export default FormWrap;
